<script>
import appConfig from "@/app.config";
import { authComputed, authMethods } from "@/state/helpers";

export default {
  page: {
    title: "404 Error Page",
    meta: [{ name: "description", content: appConfig.description }],
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    if (!localStorage.loggedIn) {
      this.redirectHandle();
    }
  },
  methods: {
    ...authMethods,
    // Method is used to handle redrection of user
    redirectHandle() {
      this.logout();
      this.$router.push("/login");
    },
  },
};
</script>
<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4
            </h1>
            <h4 class="text-uppercase">Sorry, page not found</h4>
            <div class="mt-5 text-center">
              <router-link
                class="btn btn-primary"
                to="/kiosk-status"
                v-if="user && user.user.user_type == 'super_admin'"
                >Back to Kiosk Status</router-link
              >
              <router-link
                class="btn btn-primary"
                to="/domain"
                v-else-if="user && user.user.user_type == 'pbx_admin_staff'"
                >Back to Domain List</router-link
              >
              <router-link class="btn btn-primary" to="/dashboard" v-else
                >Back to Dashboard</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
